export function removeDuplicates<T extends { id: string | number }>(
	items: T[],
	getKey: (item: T) => string | number = item => item.id
): T[] {
	const seen = new Set<string | number>();

	return items.filter(item => {
		const key = getKey(item);

		if (seen.has(key)) {
			return false;
		}

		seen.add(key);

		return true;
	});
}
